<div *ngIf="model" class="w-75 mx-auto details-container pt-3 mt-5 container">
    <app-substitution-request-list-item-body [model]="model" [showStatus]="false"></app-substitution-request-list-item-body>

    <div class="row no-gutters mt-2">
        <div class="col-auto">
            <div class="info-container d-flex flex-column align-items-center">
                <div *ngIf="requestIsOpen" class="badge badge-pill badge-secondary">
                    {{ 'SubRequestDetails.StatusOpen' | translate }}
                </div>
                <div *ngIf="requestIsClosed" class="badge badge-pill badge-success">
                    {{ 'SubRequestDetails.StatusClosed' | translate }}
                </div>
                <div *ngIf="requestIsCancelled" class="badge badge-pill badge-danger">
                    {{ 'SubRequestDetails.StatusCanceled' | translate }}
                </div>
                <div *ngIf="requestIsOverdue" class="badge badge-pill badge-warning">
                    {{ 'SubRequestDetails.StatusOverdue' | translate }}
                </div>

                <div class="btn btn-light btn-sm mt-4 cancel-request-button clickable" *ngIf="requestIsOpen"
                    (click)="onRequestCanceled()">
                    {{ 'SubRequestDetails.CancelSubRequest' | translate }}</div>
            </div>
        </div>
        <div class="col">
            <div class="proposal-acceptance-area">
                <div *ngIf="model.submitterComment">
                    <div class="row no-gutters">
                        <div class="col-auto mr-3">
                            <app-provider-avatar-photo [photoUrl]="model.instructorPhotoUrl"
                                [firstName]="model.instructorFirstName" [lastName]="model.instructorLastName"
                                [width]="50" [height]="50"></app-provider-avatar-photo>
                        </div>
                        <div class="col smaller-line-height">
                            <div><small class="font-weight-bold">{{model.instructorFirstName}}
                                    {{model.instructorLastName}}</small></div>
                            <div><small
                                    class="font-weight-light">{{model.requestCreationDate | bcDate: 'ddd, DD MMM'}}</small>
                            </div>
                            <div><small class="font-weight-light">"{{model.submitterComment}}"</small></div>
                        </div>
                    </div>
                </div>
                <hr>
                <div *ngIf="model.proposals && model.proposals.length > 0; else noProposals">
                    {{'SubRequestDetails.ProposalsReceived' | translate}}
                    <span *ngIf="requestIsOpen" [showIfPrivileges]="'SubBoard.canManageSubstitutionRequests'"
                        [clubIds]="model.clubId">
                        {{'SubRequestDetails.SelectOneOfThem' | translate}}
                    </span>
                </div>
                <ng-template #noProposals>
                    <div>{{'SubRequestDetails.NoProposalsReceived' | translate}}
                        <span *ngIf="requestIsOpen" [showIfPrivileges]="'SubBoard.canManageSubstitutionRequests'"
                            [clubIds]="model.clubId">
                            {{'SubRequestDetails.WaitOrSelectManually' | translate}}
                        </span>
                    </div>
                </ng-template>
                <div class="w-50">
                    <div *ngFor="let proposal of model.proposals">
                        <div class="my-3">
                            <app-proposal-list-item [model]="proposal" [clubId]="model.clubId"
                                (proposalRejected)="onProposalRejected($event)"
                                (proposalApproved)="onProposalApproved($event)">
                            </app-proposal-list-item>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-9 col-md-12">
                            <div *ngIf="requestIsOpen" [showIfPrivileges]="'SubBoard.canManageSubstitutionRequests'"
                                [clubIds]="model.clubId">
                                <div *ngIf="model.proposals && model.proposals.length > 0">
                                    <small>{{'SubRequestDetails.ChooseOther' | translate}}</small>
                                </div>
                                <div class="d-flex justify-content-between align-items-start">
                                    <app-instructor-search-component style="flex-grow: 3" class="mr-3"
                                        id="instructor-search" (instructorSelected)="onInstructorSelected($event)"
                                        [clubIds]="model.clubId | singleItemArray" [selectedInstructorModel]="null">
                                    </app-instructor-search-component>
                                    <button type="button " class="btn btn-success" [disabled]="!selectedInstructor"
                                        title="{{'SubRequestDetails.ConfirmTooltip' | translate}}"
                                        (click)="onConfirmOtherInstructor()">{{'SubRequestDetails.Confirm' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>




</div>